module.exports = __webpack_public_path__ + "static/img/14000692.d76f6e38.png";